import axios from "axios";
import endpoints from "../utils/endpoints";
import { accessToken } from "../utils/token";

const getAllRegions = async (params: any) => {
  const { data: response } = await axios.get(endpoints.REGION, {
    headers: {
      Authorization: accessToken,
    },
    params,
  });

  return response;
};

const viewRegion = async (id: number | string) => {
  const { data: response } = await axios.get(`${endpoints.REGION}/${id}`, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const createRegion = async (params: { name: string }) => {
  const { data: response } = await axios.post(endpoints.REGION, params, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const updateRegion = async (params: { id: number | string; name: string }) => {
  const { id, ...body } = params;
  const { data: response } = await axios.patch(`${endpoints.REGION}/${id}`, body, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const deleteRegion = async (id: number | string) => {
  const { data: response } = await axios.delete(`${endpoints.REGION}/${id}`, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const regionService = {
  getAllRegions,
  viewRegion,
  createRegion,
  updateRegion,
  deleteRegion,
};

export default regionService;